import { render, staticRenderFns } from "./ProjectSites.vue?vue&type=template&id=524a348e&"
import script from "./ProjectSites.vue?vue&type=script&lang=js&"
export * from "./ProjectSites.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSites.vue?vue&type=style&index=0&id=524a348e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports